import { styled } from '@mui/material/styles';
import { InputBase } from '@mui/material';
import { TextFieldProps } from './text-field-interfaces';

export const TextFieldStyled = styled(InputBase)<TextFieldProps>(({ theme }) => ({
  '&.MuiInputBase-root': {
    color: theme.palette.text.primary,
  },
  '& .MuiInputBase-input': {
    padding: '6px 0 7px 0',
    borderRadius: theme.spacing(0.5),

    '&[type=time]': {
      cursor: 'text',
    },
    '&[type=time]::-webkit-calendar-picker-indicator': {
      cursor: 'pointer',
    },
  },
  '& .MuiInputBase-inputSizeSmall': {
    padding: '2px 0 0px 0',
  },
}));
